import * as React from 'react';
import {
  BookIcon,
  BookOpenIcon,
  CircuitBoardIcon,
  CodeIcon,
  CuboidIcon,
  FileBarChartIcon,
  LayoutIcon,
  MapIcon,
  SendHorizonalIcon,
  ShapesIcon,
  VideoIcon
} from 'lucide-react';

import { routes } from '@workspace/routes';
import {
  InstagramIcon,
  LinkedInIcon
} from '@workspace/ui/components/brand-icons';

import type { Dictionary } from '~/app/[lang]/dictionaries';

type MenuLink = {
  title: string;
  href: string;
  external: boolean;
  items?: MenuLink[];
  icon?: React.ReactNode;
  description?: string;
  translationKey?: keyof Dictionary['nav'];
};

export const MENU_LINKS: MenuLink[] = [
  // {
  //   title: 'Product',
  //   items: [
  //     {
  //       title: 'Portfolios',
  //       description: 'Visualize your portfolio to track and share projects.',
  //       icon: <LayoutIcon className="size-5 shrink-0" />,
  //       href: '#',
  //       external: false
  //     },
  //     {
  //       title: 'Polygons',
  //       description: 'Upload or draw project area polygons.',
  //       icon: <ShapesIcon className="size-5 shrink-0" />,
  //       href: '#',
  //       external: false
  //     },
  //     {
  //       title: 'Analysis',
  //       description:
  //         'Run computations to analyze carbon potential and landscape characteristics.',
  //       icon: <CircuitBoardIcon className="size-5 shrink-0" />,
  //       href: '#',
  //       external: false
  //     },
  //     {
  //       title: 'Map Layers',
  //       description: 'Visualize global datasets around your project boundary.',
  //       icon: <MapIcon className="size-5 shrink-0" />,
  //       href: '#',
  //       external: false
  //     },
  //     {
  //       title: 'Reports',
  //       description:
  //         'Generate custom reports with analysis from computations such as estimated VCUs and eligible land.',
  //       icon: <FileBarChartIcon className="size-5 shrink-0" />,
  //       href: '#',
  //       external: false
  //     }
  //   ]
  // },
  {
    title: 'Docs',
    href: routes.marketing.Docs,
    external: false,
    translationKey: 'docs'
    // items: []
  },
  // {
  //   title: 'Resources',
  //   items: [
  //     {
  //       title: 'Contact',
  //       description: 'Reach out for assistance',
  //       icon: <SendHorizonalIcon className="size-5 shrink-0" />,
  //       href: routes.marketing.Contact,
  //       external: false
  //     },
  //     {
  //       title: 'Roadmap',
  //       description: 'See what is coming next',
  //       icon: <LayoutIcon className="size-5 shrink-0" />,
  //       href: routes.marketing.Roadmap,
  //       external: true
  //     },
  //     {
  //       title: 'Docs',
  //       description: 'Learn how to use our platform',
  //       icon: <BookOpenIcon className="size-5 shrink-0" />,
  //       href: routes.marketing.Docs,
  //       external: false
  //     }
  //   ]
  // },
  {
    title: 'Plans',
    href: routes.marketing.Pricing,
    external: false,
    translationKey: 'plans'
  },
  {
    title: 'Contact',
    href: routes.marketing.Contact,
    external: false,
    translationKey: 'contact'
  }
  // {
  //   title: 'Blog',
  //   href: routes.marketing.Blog,
  //   external: false
  // },
  // {
  //   title: 'Story',
  //   href: routes.marketing.Story,
  //   external: false
  // }
];

type FooterLink = {
  name: string;
  href: string;
  external: boolean;
  translationKey?: keyof Dictionary['footer']['links'];
};

type FooterLinkGroup = {
  title: string;
  links: FooterLink[];
  translationKey?: keyof Dictionary['footer']['sections'];
};

export const FOOTER_LINKS: FooterLinkGroup[] = [
  // {
  //   title: 'Product',
  //   links: [
  //     { name: 'Portfolios', href: '#', external: false },
  //     { name: 'Polygons', href: '#', external: false },
  //     { name: 'Analysis', href: '#', external: false },
  //     { name: 'Map Layers', href: '#', external: false },
  //     { name: 'Reports', href: '#', external: false }
  //   ]
  // },
  {
    title: 'Resources',
    translationKey: 'resources',
    links: [
      {
        name: 'Contact',
        href: routes.marketing.Contact,
        external: false,
        translationKey: 'contact'
      },
      // { name: 'Roadmap', href: routes.marketing.Roadmap, external: true },
      {
        name: 'Docs',
        href: routes.marketing.Docs,
        external: false,
        translationKey: 'docs'
      }
    ]
  },
  // {
  //   title: 'About',
  //   links: [
  //     { name: 'Story', href: routes.marketing.Story, external: false },
  //     { name: 'Blog', href: routes.marketing.Blog, external: false },
  //     { name: 'Careers', href: routes.marketing.Careers, external: false }
  //   ]
  // }
  {
    title: 'Legal',
    translationKey: 'legal',
    links: [
      // {
      //   name: 'Terms of Use',
      //   href: routes.marketing.TermsOfUse,
      //   external: false
      // },
      {
        name: 'Privacy Policy',
        href: routes.marketing.PrivacyPolicy,
        external: false,
        translationKey: 'privacyPolicy'
      }
      // {
      //   name: 'Cookie Policy',
      //   href: routes.marketing.CookiePolicy,
      //   external: false
      // }
    ]
  }
];

export const SOCIAL_LINKS = [
  // {
  //   name: 'X (formerly Twitter)',
  //   href: '~/',
  //   icon: <XIcon className="size-4 shrink-0" />
  // },
  {
    name: 'LinkedIn',
    href: 'https://www.linkedin.com/company/earthshotlabs',
    icon: <LinkedInIcon className="size-4 shrink-0" />
  },
  {
    name: 'Instagram',
    href: 'https://www.instagram.com/earthshotlabs',
    icon: <InstagramIcon className="size-4 shrink-0" />
  }
];

export const DOCS_LINKS = [
  {
    title: 'Getting Started',
    icon: <CuboidIcon className="size-4 shrink-0 text-muted-foreground" />,
    items: [
      {
        title: 'Introduction',
        href: '/docs',
        items: []
      },
      {
        title: 'Release Notes',
        href: '/docs/release-notes'
      },
      {
        title: 'Carbon Development Journey',
        href: '/docs/carbon-development-journey',
        items: []
      },
      {
        title: 'LandOS Tutorial',
        href: '/docs/walkthrough_tutorial',
        items: []
      },
      {
        title: 'ForestLoop Tutorial',
        href: '/docs/forest-loop-documentation',
        items: []
      }
    ]
  },
  {
    title: 'Documentation',
    icon: <BookIcon className="size-4 shrink-0 text-muted-foreground" />,
    items: [
      {
        title: 'ARR Prefeasibility',
        href: '/docs/arr-prefeasibility',
        items: []
      },
      {
        title: 'ARR Project Pipeline',
        href: '/docs/arr-project-pipeline',
        items: []
      },
      {
        title: 'REDD Prefeasibility',
        href: '/docs/redd-prefeasibility-documentation',
        items: []
      },
      {
        title: 'Customized Native Restoration Carbon Removals',
        href: '/docs/arr-nativeremovals-customized'
      },
      {
        title: 'Map Catalog',
        href: '/docs/global_map_sources'
      },
      {
        title: 'AI Chatbot',
        href: '/docs/ai-chatbot'
      },
      {
        title: 'Biophysical Characterization',
        href: '/docs/general-polygon'
      },
      {
        title: 'Land Eligibility',
        href: '/docs/land-eligibility-methods'
      },
      {
        title: 'Land Cover Point Sampling',
        href: '/docs/landcover-point-sampling'
      },
      {
        title: 'Natural Risk',
        href: '/docs/natural-risk'
      }
    ]
  },
  {
    title: 'Developers',
    icon: <CodeIcon className="size-4 shrink-0 text-muted-foreground" />,
    items: [
      {
        title: 'MCP Server',
        href: '/docs/mcp-server',
        items: []
      }
    ]
  },
  {
    title: 'Webinars',
    icon: <VideoIcon className="size-4 shrink-0 text-muted-foreground" />,
    items: [
      {
        title: '10 steps to develop a carbon project',
        href: '/docs/10-steps-to-develop-a-carbon-project'
      },
      {
        title: 'How to develop a VM0047 ARR project',
        href: '/docs/vm0047-arr-project'
      },
      {
        title:
          'Leakage: what it is, why it matters, and how to calculate it under VM0047',
        href: '/docs/leakage'
      }
    ]
  },
  {
    title: 'Resources',
    icon: (
      <FileBarChartIcon className="size-4 shrink-0 text-muted-foreground" />
    ),
    items: [
      {
        title: 'Standards and Methodologies',
        href: '/docs/standards-and-methodologies'
      }
    ]
  }
];
